export const ONLINE = '1';
export const OFFLINE = '2';
export const AWAY = '3';

export default [ONLINE, OFFLINE, AWAY];
